import api from './../services/api.js';

export default {
  namespaced: true,
  state: {
    people: null,
    news: null
  },
  mutations: {
    setTeam (state, team) {
      state.people = team;
    },
    setNews (state, about) {
      state.news = about;
    }
  },
  actions: {
    getTeam: ({commit}) => {
      api.getTeam().then((resp) => {
        commit('setTeam', resp.data);
        return resp.data;
      });
    },
    getNews: ({commit}) => {
      api.getOdNews().then((resp) => {
        commit('setNews', resp.data);
        return resp.data;
      });
    }
  }
};
